import { AmberHoc, AmberHocProps } from '../../../util';
import {
  SaveBinEstimateTargetValuesMutation as Result,
  SaveBinEstimateTargetValuesMutationVariables as Variables,
  withSaveBinEstimateTargetValues as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

export type WithSaveBinEstimateTargetValuesHocChildProps = {
  saveBinEstimateTargetValues: (
    variables: Variables
  ) => Promise<Result['saveBinEstimateTargetValues']>;
};

export const withSaveBinEstimateTargetValuesHoc: AmberHoc<
  {},
  WithSaveBinEstimateTargetValuesHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<{}, WithSaveBinEstimateTargetValuesHocChildProps, typeof component>,
    WithSaveBinEstimateTargetValuesHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        saveBinEstimateTargetValues: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }

          const result = await mutate({ variables });

          if (!result) {
            throw new Error('Unexpected server response');
          }

          const { errors, data } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data) {
            throw new Error('Unexpected server response');
          }
          return data.saveBinEstimateTargetValues;
        },
      };
    },
  })(component as any);
